var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPaidInLastMonth = function SvgPaidInLastMonth(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.125 21.375V34.875",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.125 32.625H25.875C25.875 31.4315 25.4009 30.2869 24.557 29.443C23.7131 28.5991 22.5685 28.125 21.375 28.125H15.75C15.75 26.9315 15.2759 25.7869 14.432 24.943C13.5881 24.0991 12.4435 23.625 11.25 23.625H1.125",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 28.125H15.75",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.36 27.012C31.9948 25.7942 33.2667 24.1538 34.0389 22.2671C34.8111 20.3805 35.0543 18.319 34.7423 16.3044C34.4304 14.2899 33.5752 12.3985 32.2686 10.8337C30.962 9.26888 29.2536 8.08989 27.327 7.42353L30.1065 2.66853C30.1981 2.51228 30.2464 2.33442 30.2464 2.15328C30.2464 1.97214 30.1981 1.79428 30.1065 1.63803C30.0114 1.48031 29.8769 1.35006 29.7162 1.2601C29.5555 1.17015 29.3742 1.1236 29.19 1.12503H18.06C17.8763 1.12412 17.6956 1.17092 17.5355 1.26085C17.3753 1.35077 17.2413 1.48074 17.1465 1.63803C17.0549 1.79428 17.0066 1.97214 17.0066 2.15328C17.0066 2.33442 17.0549 2.51228 17.1465 2.66853L19.926 7.42353C17.7251 8.18439 15.8156 9.61146 14.4626 11.5067C13.1095 13.4019 12.3799 15.6714 12.375 18",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.55 20.7661C20.8749 21.1927 21.2978 21.5348 21.7829 21.7633C22.2681 21.9917 22.8012 22.0999 23.337 22.0786C25.0455 22.0786 26.4315 21.0391 26.4315 19.7581C26.4315 18.4771 25.0455 17.4391 23.337 17.4391C21.6285 17.4391 20.25 16.3996 20.25 15.1171C20.25 13.8346 21.636 12.7966 23.343 12.7966C23.8789 12.7748 24.4121 12.8828 24.8973 13.1113C25.3825 13.3398 25.8054 13.6821 26.13 14.1091",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.343 22.0785V23.625",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.343 11.25V12.7965",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaidInLastMonth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paid-in-last-month.47c30c89.svg";
export { ForwardRef as ReactComponent };